import { css } from '@emotion/react';

const base = css`
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin: 0 4px;

    .ant-popover-inner-content {
        padding: 0;
    }
`;

const popOver = css`
    .ant-popover-inner-content {
        padding: 0;
        width: 400px; /* Fixed width untuk popover */
        max-width: 400px;
    }
`;

const notifBell = css`
    cursor: pointer;
    background-color: #fff;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 1px solid #d9d9d9;
    padding: 4px;
`;

const notifWrapper = css`
    height: 300px;
    width: 400px; /* Fixed width */
    max-width: 400px;
    overflow: scroll;
    padding: 12px 16px;
    box-sizing: border-box;

    .empty-content {
        margin: 92px 32px;
    }
`;

const notifSetting = css`
    border-top: 1px solid #000;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 8px;
    padding: 8px;
    width: 400px; /* Fixed width */
    max-width: 400px;
    box-sizing: border-box;
`;

const btnSeeAllNotif = css`
    cursor: pointer;
    color: #00aa5b;
    font-size: 12px;
    font-weight: 600;

    &:hover {
        text-decoration: underline;
    }
`;

const btnDeleteAllNotif = css`
    cursor: pointer;
    color: #8c8c8c;
    font-size: 12px;
    font-weight: 600;

    &:hover {
        color: #cf1322;
    }
`;

const notifContainer = css`
    padding: 0;
    margin-top: 12px;
    width: 100%;
    max-width: 100%;

    &:first-child {
        margin-top: 0;
    }
`;

const notificationTitle = css`
    margin-bottom: 4px;
    font-weight: 500;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

const notificationItem = css`
    display: flex;
    border-bottom: 1px solid #888;
    padding: 8px 0;
    cursor: pointer;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;

    &:last-of-type {
        border-bottom: none;
    }

    &:hover {
        background-color: rgb(243, 255, 255);
    }
`;

const itemContainer = css`
    margin: 0 12px;
    width: 200px; /* Fixed width untuk content */
    max-width: 200px;
    min-width: 200px;
    overflow: hidden;
`;

const itemText = css`
    margin-bottom: 12px;
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-break: break-word;
    line-height: 1.4;
`;

const itemTime = css`
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

const btnNotifDelete = css`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 32px;
    height: 32px;
`;

const ackedNotif = css`
    color: rgb(195, 194, 194);
`;

// Container utama untuk fixed width
const notificationContainer = css`
    width: 400px;
    max-width: 400px;
    min-width: 400px;
    box-sizing: border-box;
    overflow: hidden;
`;

// Mobile styles
const mobileStyles = css`
    @media only screen and (min-device-width: 0px) and (max-device-width: 699px) {
        position: relative;
        display: inline-block;
        right: 14px;
        top: 0;
        margin: 0;

        ${notificationContainer} {
            width: 100vw;
            max-width: 95vw;
            min-width: 320px;
        }

        ${notifWrapper} {
            width: 100%;
            max-width: 100%;
        }

        ${notifSetting} {
            width: 100%;
            max-width: 100%;
        }

        ${itemContainer} {
            width: calc(100% - 80px);
            max-width: calc(100% - 80px);
            min-width: auto;
        }
    }
`;

const styles = {
    base,
    popOver,
    notifBell,
    notifWrapper,
    notifSetting,
    notifContainer,
    btnSeeAllNotif,
    btnDeleteAllNotif,
    notificationTitle,
    notificationItem,
    itemContainer,
    itemText,
    itemTime,
    btnNotifDelete,
    ackedNotif,
    notificationContainer,
    mobileStyles,
};

export default styles;
